import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { toggleSidebar } from '../../store/actions/layout';

const Services = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const { isSidebarOpened } = useSelector((state) => state.layout);

   useEffect(() => {
      location.hash && document.querySelector(`a[href="${location.hash}"]`).click();
   }, []);

   return (
      <>
         <a style={{ display: 'none' }} href='#special-post'></a>
         <a style={{ display: 'none' }} href='#inventory'></a>
         <a style={{ display: 'none' }} href='#packing'></a>
         <a style={{ display: 'none' }} href='#international-post'></a>
         <a style={{ display: 'none' }} href='#IR-post'></a>
         <a style={{ display: 'none' }} href='#insurance'></a>
         <a style={{ display: 'none' }} href='#in-place'></a>
         <h1
            style={{
               color: 'var(--primary)',
               fontSize: '1.9rem',
               textAlign: 'center',
               padding: '20px 16px 12px',
            }}
         >
            خدمات کالاپست
         </h1>
         <main className='servises' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
            <div className='servises__content'>
               <div id='special-post' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/post.png' alt='' />
                        <h3 className='servises__blocks-titles'>پست ویژه</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        از طریق تماس تلفنی و یا استفاده از اپلیکیشن کالاپست پس از ثبت سفارش نماینده
                        سیار کالاپست جهت جمع آوری بسته اقدام نموده پس از انجام مراحل ارسال، بسته در
                        محل حضور گیرنده تحویل داده میشود. استفاده از این سرویس برای کلیه مشتریان
                        حقیقی و حقوقی امکانپذیر است.
                        <br />
                        ویژگیهای این سرویس عبارت است از:
                     </p>
                     <ul className='servises__blocks-list'>
                        <li>
                           درب به درب (D2D) درب به درب به معنی دریافت بسته از محل فرستنده و تحویل
                           بسته به محل گیرنده میباشد.
                        </li>
                        <li>امکان رهگیری بسته</li>
                        <li>امکان پیگیری بسته</li>
                        <li>امکان برآورد قیمت و زمان ارسال بسته</li>
                        <li>برآورد قیمت براساس مسافت، حجم و وزن بسته ها صورت میگیرد.</li>
                        <li>خدمات مشتریان: پاسخگویی تلفنی هوشمند آنلاین</li>
                     </ul>
                  </div>
               </div>
               <div id='inventory' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/inventory.png' alt='' />
                        <h3 className='servises__blocks-titles'>انبارداری</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        انبار لجستیک را می‌توان یکی از نیازهای اساسی هر بنگاه اقتصادی به شمار آورد.
                        تاسیس و راهبری یک انبار دارای پیچیدگی‌های مختلفی از جمله هزینه‌های مالی
                        اولیه، نیروی انسانی و... است که هر فروشگاه اینترنتی و کسب و کار نوپایی قادر
                        به انجام و تامین آن نخواهد بود. هدف از تشکیل و ایجاد انبارهای لجستیکی شرکت
                        کالا پست تامین، نگهداری و در دسترس قرار دادن مجموعه کالاهای مشتریان محترم
                        است. از جمله امکاناتی که انبارهای لجستیک شرکت کالاپست در اختیار مشتریان قرار
                        می‌دهد عبارت است از:
                     </p>
                     <ul className='servises__blocks-list'>
                        <li>
                           <span> </span>• برخورداری از دوربین‌های مداربسته و نیروی نگهبانی
                        </li>
                        <li>
                           <span> </span> • صدور بیمه نامه برای تمامی محمولات
                        </li>
                        <li>
                           <span> </span> • مدیریت لحظه ای موجودی انبار
                        </li>
                        <li>
                           <span> </span> • خدمات بسته بندی و ارسال محمولات به درب محل مورد نظر
                           مشتریان
                        </li>
                        <li>
                           <span> </span> • خدمات پرداخت در محل به مشتریان
                        </li>
                     </ul>
                  </div>
               </div>
               <div id='packing' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/post (2).png' alt='' />
                        <h3 className='servises__blocks-titles'>بسته بندی</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        در ارسال بسته ها، یکی از نکات مهم و ضروری، به کارگیری بسته بندی مناسب است.
                        استفاده از روشهای نوین بسته بندی، ضمن حفظ امنیت کالا و سلامت بسته ها، باعث
                        میشود تا طیف گسترده ای از کالاها و خدمات به مشتریان ارائه گردد. شرکت کالاپست
                        جهت رفاه مشتریان و افزایش هرچه بیشتر کیفیت، بسته بندی های متفاوتی را براساس
                        ابعاد و وزن بسته ارائه میدهد.
                     </p>
                  </div>
               </div>
               <div id='international-post' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img
                           alt=''
                           className='services__blocks-images'
                           src='img/international.png'
                        />
                        <h3 className='servises__blocks-titles'>پست بین الملل</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        کالاپست این خدمات را در سطح بین الملل به مشتریان ارائه میدهد. در این همکاری
                        کالاپست وظیفه ی جمع آوری و توزیع بسته در ایران را به عهده دارد و ارسال و
                        توزیع بسته خارج از مرزهای ایران به عهده ی شرکت پست ملی ایران میباشد. ارسال
                        بسته ها به سرتاسر دنیا، منطبق با قوانین بین الملل حمل ونقل امکانپذیر است.
                        ویژگیهای این سرویس عبارت است از:
                     </p>
                     <ul className='servises__blocks-list'>
                        <li>درب به درب</li>
                        <li>امکان ارسال بسته به مقاصد خارج از کشور</li>
                        <li>امکان رهگیری، پیگیری و برآورد قیمت خدمات مشتریان</li>
                        <li>پاسخگویی تلفنی هوشمند</li>
                        <li>خدمات بسته بندی</li>
                        <li>امکان برآورد زمان سیر بسته</li>
                     </ul>
                  </div>
               </div>
               <div id='IR-post' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/iran.png' alt='' />
                        <h3 className='servises__blocks-titles'>پست جمهوری اسلامی</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        شرکت کالا پست با عقد تفاهم نامه با شرکت پست ملی ایران و سرمایه گذاری بخش
                        خصوصی امکان جمع آوری،ارسال و توزیع مرسولات لجستیکی را فراهم آورده است در این
                        حوزه اقداماتی نظیر طراحی وب سایت رهگیری مرسولات اپلیکیشن نسخه اندروید جهت
                        ثبت رهگیری همچنین ایجاد خطوط ویژه جهت ارسال بار به شهر های غیر هم جوار و
                        پایخت کشور را فراهم نموده است این شرکت به یک استارت آپ نوین در مرکز نوآوری
                        شرکت ملی پست ایران به ثبت رسیده است
                     </p>
                  </div>
               </div>
               <div id='in-town' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/city.png' alt='' />
                        <h3 className='servises__blocks-titles'>ارسال درون شهری</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        سرویس ارسال بسته درون شهری next day در این سرویس در روز اول بسته ها در یک
                        روز جمع آوری و در روز بعد در همان شهر توزیع می گردد
                     </p>
                  </div>
               </div>
               <div id='insurance' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/insurance.png' alt='' />
                        <h3 className='servises__blocks-titles'>بیمه</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        فرستندگان براساس نياز و علاقه و با توجه به ارزشمند بودن محتويات مرسوله ثبتی
                        خود از جمله براي ارسال اسناد و اشياء قيمتي، اوراق بهادار، وجه نقد و ...
                        مي‌توانند از سرويس «بيمه با ارزش اظهار شده» استفاده نمايند. در اين سرويس
                        فرستنده ارزش واقعي مرسوله خود را اعلام مي‌كند و در ازاي آن مبلغي را كه
                        براساس مقررات، درصد تعيين شده‌اي از ارزش اظهار شده براي مرسوله به تفكيك
                        داخله و خارجه است، مي‌پردازد.
                     </p>
                  </div>
               </div>
               <div id='in-place' className='kards__card kards__card-services'>
                  <div className='servises__blocks-section'>
                     <div>
                        <img className='services__blocks-images' src='img/money.png' alt='' />
                        <h3 className='servises__blocks-titles'>پرداخت در محل</h3>
                     </div>
                  </div>

                  <div className='servises__blocks-explains'>
                     <p>
                        با توجه به تمایل مشتری جهت پرداخت بهای محصول در محل، شرکت کالاپست این امکان
                        را برای فروشگاهها فراهم میسازد تا به مشتریانalt="" خود امکان پرداخت در محل
                        را ارائه نمایند و در سریعترین زمان ممکن اقدام به تسویه حساب با فروشگاهها
                        مینماید.
                     </p>
                  </div>
               </div>
            </div>
            <Link to='/order' className='main__Send-package'>
               <img className='main__Send-package-img' src='./img/postfix.png' alt='' />
               <h4>ارسال بسته</h4>
            </Link>
         </main>
      </>
   );
};

export default Services;
